export const addDays = (days: number, dateParam?: string) => {
  const date = new Date(!!dateParam ? dateParam : new Date());
  const datePlus = new Date(date.setDate(date.getDate() + days));
  return datePlus;
};
